<template>
<el-card
  :body-style="{ padding: '10px' }"
  style="margin-top: 10px;"
  class="consultant-box">
  <div
    slot="header">
    {{ $t('ibe.headline_consultant') }}
  </div>
  <div
    style="float: left; margin-right: 10px">
    <img
      :src="imgUrl"/>
  </div>
  <div
    style="float: left; padding-bottom: 10px">
    <div>{{ $t('ibe.consultant_name') }}</div>
    <div>
      <a
        :href="'tel:' + $t('ibe.consultant_phone_number')">
        {{ $t('ibe.consultant_phone') }}
      </a>
    </div>
    <div>
      <a
        :href="'mailto:' + $t('ibe.consultant_email')"
        class="email">
        {{ $t('ibe.consultant_email') }}
      </a>
    </div>
  </div>
</el-card>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'ConsultantBox',
  data () {
    return {
      uriBase: window.initData.httpRoot,
      imgUrl: require('@/assets/images/consultant.png')
    }
  }
}
</script>
